import { Box, Button, Divider, Flex, Heading } from '@chakra-ui/react';
import { FaCheck, FaPlusSquare, FaShare } from "react-icons/fa";

const TitleHeader = ({
    title,
    onClick,
    buttonText,
    icon = <FaPlusSquare />,
    buttonColor = 'blue',

    secondButton = false,
    secondButtonOnClick = null,
    secondButtonText = '',
    secondButtonIcon = <FaCheck />,

    thirdButton = false,
    thirdButtonOnClick = null,
    thirdButtonText = '',
    thirdButtonIcon = <FaShare />,

    fourthButton = false,
    fourthButtonOnClick = null,
    fourthButtonText = '',
    fourthButtonIcon = <FaShare />,
    fourthButtonWb = true

}) => {
    return (
        <>
            <Flex alignItems="center" mb="6">
                <Heading size="lg" fontWeight="semiBold">{title}</Heading>
                <Box ml={10}>
                    {onClick &&
                        <Button onClick={onClick} size="xs" leftIcon={icon} colorScheme={buttonColor} variant="solid">
                            {buttonText}
                        </Button>
                    }
                    {secondButton &&
                        <Button ml={4} size="xs" onClick={secondButtonOnClick} leftIcon={secondButtonIcon} colorScheme="purple">
                            {secondButtonText}
                        </Button>
                    }

                    {thirdButton &&
                        <Button ml={4} size="xs" onClick={thirdButtonOnClick} leftIcon={thirdButtonIcon} colorScheme="green" color={'white'}>
                            {thirdButtonText}
                        </Button>
                    }

                    {fourthButton &&
                        <Button ml={4} size="xs" onClick={fourthButtonOnClick} leftIcon={fourthButtonIcon} colorScheme={fourthButtonWb ? "pink" : ""} color={'white'}>
                            {fourthButtonText}
                        </Button>
                    }
                </Box>
            </Flex >
            <Divider />
        </>
    );
};

export default TitleHeader;
